import { render, staticRenderFns, recyclableRender, components } from "./userinfo.vue?vue&type=template&id=5cdc0ea6&scoped=true&"
var renderjs
import script from "./userinfo.vue?vue&type=script&lang=js&"
export * from "./userinfo.vue?vue&type=script&lang=js&"
import style0 from "./userinfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./userinfo.vue?vue&type=style&index=1&id=5cdc0ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdc0ea6",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/userinfo/userinfo.vue"
export default component.exports